// CLASSES
import AppConfig from "@classes/AppConfig";
import Validator from "../../../../../classes/Validator";

export default function(props, state)
{
    if (AppConfig.get("developmentOptions").ignoreFullfillment === true)
    {
        return true;
    }

    const {fields} = state;

    if (fields.radio_account_type.options[0].checked && fields.selectedAccount === null)
    {
        return false;
    }

    if (fields.radio_account_type.options[1].checked)
    {
        if (fields.futur_new_bank.length <= 0)
        {
            return false;
        }

        if (fields.futur_new_holder.length <= 0)
        {
            return false;
        }

        if (fields.futur_new_clearing.length <= 3)
        {
            return false;
        }

        if (fields.futur_new_account.length <= 0)
        {
            return false;
        }

        if (fields.futur_new_bank === "-" && fields.futur_new_bank_custom.length <= 0)
        {
            return false;
        }

        if (state.fields.shouldValidateBankAccount && !state.fields.skipBankAccountValidation)
        {
            // Validate the bank account clearing code and number
            const clearingValid = Validator.validateClearingNumber(fields.futur_new_clearing, fields.futur_new_bank, state.availableBanks);
            if (!clearingValid)
            {
                console.log("Invalid clearing no", fields.futur_new_clearing);
                return false;
            }

            let bankNoToValidate = fields.futur_new_clearing + ", " + fields.futur_new_account;
            const accountValid = window.kontonummer(bankNoToValidate);

            if (!accountValid)
            {
                return false;
            }
        }
    }

    return true;
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Futur/Withdrawal/AccountChooser.fulfillment.js